import { Capacitor } from "@capacitor/core";
import { Preferences } from "@capacitor/preferences";

/** Dans les apps iOS/Android, l'authentification passe par un jeton Bearer (pas de cookies tiers en WebView). */
// Uniquement quand l'interface est embarquée dans l'application (capacitor:// ou https://localhost) ; si l'application charge le site en ligne, les cookies suffisent.
export const isNative = Capacitor.isNativePlatform() && (window.location.protocol === "capacitor:" || window.location.hostname === "localhost");

const KEY = "gbc.session-token";
let cached: string | null = null;

export async function loadToken() {
  if (!isNative) return null;
  cached = (await Preferences.get({ key: KEY })).value;
  return cached;
}
export const getToken = () => cached;
export async function setToken(token: string | null) {
  cached = token;
  if (!isNative) return;
  if (token) await Preferences.set({ key: KEY, value: token });
  else await Preferences.remove({ key: KEY });
}
